import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import isEmpty from 'lodash/isEmpty';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { contentToLinkedContent } from 'libs/content/transformers/contentToLinkedContent';
import { getDependencies, updateDependencies } from 'redux/content';
import { getContent } from 'services/networking/content';

var useDependency = function useDependency(contentId) {
  var dispatch = useDispatch();
  var dependencies = useSelector(getDependencies);

  var _useState = useState(false),
      isContentFetched = _useState[0],
      setIsContentFetched = _useState[1];

  var fetchContent = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fetchedContent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getContent(contentId);

          case 3:
            fetchedContent = _context.sent;

            if (!(fetchedContent === undefined)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            dispatch(updateDependencies(_defineProperty({}, contentId, fetchedContent)));
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return");

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  })), [contentId, dispatch]);
  var linkedContent = useMemo(function () {
    if (isEmpty(contentId)) {
      return undefined;
    }

    var dependencyContent = dependencies[contentId];

    if (dependencyContent) {
      return contentToLinkedContent(dependencyContent);
    }

    if (!isContentFetched) {
      setIsContentFetched(true);
      void fetchContent();
    }

    return undefined; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentId, dependencies]);
  return linkedContent;
};

export default useDependency;